<template>
  <div>
    <app-spinner v-if="!is_page_loaded" />
    <template v-else>
      <app-cells>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            class="custom-date-time-picker custom-date-time-picker--range"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            shortcut=""
            @is-hidden="onIsHiddenPicker"
            @input="onPickerInput"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            color="#77b017"
            button-color="#77b017"
            overlay
            no-header
            no-label
            locale="en"
            range
            ref="date_picker"
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
        <app-input
          @input.native="onLeadSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by lead name"
          name="search"
        />
        <app-select
          @input="onChangeFilter"
          v-model="filter_hotel"
          :reduce="item => item.id"
          :options="hotels_options"
          placeholder="Choose hotel"
          class="select--300"
        />
        <app-select
          @input="onChangeFilter"
          v-model="filter_hotel_chain"
          :reduce="item => item.id"
          :options="hotels_chain_options"
          placeholder="Hotel Chain"
          class="select--300"
        />
        <app-filters
          @change="onChangeFilter"
          v-model="filter_paid"
          :filters="paid_filters"
          name="filterPaid"
        />
      </app-cells>
      <v-client-table
        :data="table_payment_plan.items"
        :columns="table_payment_plan.columns"
        :options="table_payment_plan.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__payment><div class="table-default__left">Payment</div></template>
        <template #h__meal><div class="table-default__left">Meal</div></template>
        <template #h__client><div class="table-default__left">Client</div></template>
        <template #h__amount><div class="table-default__left">Amount</div></template>
        <template #h__select>
          <label
            v-if="table_payment_plan.items.filter(item => !item.paid).length"
            class="checkbox checkbox--table"
          >
            <input
              v-model="checked_all"
              type="checkbox"
              name="checked_all"
              ref="mainCh"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #type="{ row }">
          <span v-if="row.type === 'deposit'" class="status-tag" :style="{ 'backgroundColor': '#439ad1' }">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
          <span v-if="row.type === 'final'" class="status-tag" :style="{ 'backgroundColor': '#77b017' }">
            {{ row.type[0].toUpperCase() + row.type.slice(1) }}
          </span>
        </template>
        <template #select="{ row }">
          <label v-if="!row.paid && !row.bank_payment" class="checkbox  checkbox--table">
            <input
              v-model="checked"
              type="checkbox"
              :value="row"
              :name="row.id"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #date="{ row }">
          <span v-if="row.category === 'overdue'" class="status-tag" :style="{ 'backgroundColor': '#e85c20' }">
            {{ dateFormat(row.date) }}
          </span>
          <span v-if="row.category === 'upcoming'" class="status-tag" :style="{ 'backgroundColor': '#439ad1' }">
            {{ dateFormat(row.date) }}
          </span>
          <template v-if="!row.category">
            {{ dateFormat(row.date) }}
          </template>
        </template>
        <template #payment="{ row }">
          <div class="table-default__left">{{ amountFormat(row.amount) }}$</div>
        </template>
        <template #meal="{ row }">
          <div class="table-default__left">
            <div class="table-default__controls">
              <router-link
                :to="{ name: 'reservation-meal-general', params: { id: row.reservation_meal.id } }"
                class="table-default__link-border"
              >
                Meal (#{{ row.reservation_meal.id }})
              </router-link>
            </div>
          </div>
        </template>
        <template #client="{ row }">
          <div class="table-default__left">
            <div v-if="is_general_manager" class="table-default__controls">
              <router-link
                :to="{ name: 'leads-detail-reservations', params: { id: row.reservation_meal.lead.id } }"
                class="table-default__link-border"
              >
                {{ row.reservation_meal.lead.name }}
              </router-link>
            </div>
            <template v-else>{{ row.reservation_meal.lead.name }}</template>
          </div>
        </template>
        <template #order="{ row }">
          {{ dateFormat(row.reservation_meal.min_date) }}
        </template>
        <template #amount="{ row }">
          <div class="table-default__left">
            <a
              v-if="row.invoice.invoice"
              :href="row.invoice.attachment.file"
              class="table-default__link-border"
              target="_blank"
            >
              {{ amountFormat(row.invoice.amount_total) }}$
            </a>
            <template v-else>
              {{ amountFormat(row.invoice.amount_total) }}$
            </template>
          </div>
        </template>
      </v-client-table>
      <app-cells :position="pagination_payment_plan.pages > 1 ? 'between' : 'end'">
        <paginate
          :clickHandler="onClickPaymentPlanPagination"
          v-if="pagination_payment_plan.pages > 1"
          v-model="pagination_payment_plan.page"
          :page-count="pagination_payment_plan.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
        <app-table-records
          :all="pagination_payment_plan.count"
          :count="table_payment_plan.items.length"
          :page="pagination_payment_plan.page"
          :limit="40"
        />
      </app-cells>
    </template>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">
        Selected payments: <span>{{ checked.length }}</span> ({{ checkedSum ? `${amountFormat(checkedSum)}$` : '' }})
      </div>
      <app-button @click.native="onMakePayment" ref="make_payments">Request payment</app-button>
    </div>
  </div>
</template>

<script>
import {
  getHotelsChain,
  getHotelsListSearch,
  getReservationsPaymentPlanMeals,
  postReservationsPaymentRequest
} from '@/http'
import { format, parse } from 'date-fns'
import debounce from 'lodash/debounce'
import moment from 'moment/moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'ReservationPaymentRequestsMeals',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      is_page_loaded: false,
      table_preloader: false,
      table_payment_plan: {
        items: [],
        columns: ['select', 'type', 'date', 'payment', 'meal', 'client', 'order', 'amount'],
        options: {
          headings: {
            type: 'Type',
            date: 'Date',
            payment: 'Payment',
            meal: 'Meal',
            client: 'Client',
            order: 'Order',
            amount: 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_payment_plan: {
        pages: 1,
        page: 1,
        count: 1,
      },
      search: '',
      hotels_options: [],
      hotels_chain_options: [],
      filter_hotel: null,
      filter_hotel_chain: null,
      filter_paid: 'false',
      paid_filters: [
        { value: 'false', label: 'Not paid' },
        { value: 'true', label: 'Paid' },
      ],
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      filter_dates: null,
      custom_shortcuts: [
        {
          key: 'next30Days',
          label: 'Next 30 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(30, 'days')
            }
          }
        },
        {
          key: 'next60Days',
          label: 'Next 60 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(60, 'days')
            }
          }
        },
        {
          key: 'next90Days',
          label: 'Next 90 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(90, 'days')
            }
          }
        },
      ],
      date_picker_error: false,
    }
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table_payment_plan.items.forEach(item => {
          if (!item.paid && !this.checked.map(item_c => item_c.id).includes(item.id)) this.checked.push(item)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  computed: {
    checkedSum() {
      if (this.checked) {
        return this.checked
          .map(item => item.amount)
          .reduce((a, b) => {
            return Number(a) + Number(b)
          }, 0)
      } else {
        return ''
      }
    },
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  created() {
    this.fetchPaymentPlanItems()
    getHotelsListSearch({ active: 'true' }).then(res => { this.hotels_options = res.data })
    getHotelsChain().then(res => { this.hotels_chain_options = res.data })
  },
  methods: {
    onChangeFilter() {
      this.pagination_payment_plan.page = 1
      this.fetchPaymentPlanItems()
    },
    onIsHiddenPicker() {
      this.fetchPaymentPlanItems()
    },
    onPickerInput() {
      if (!this.$refs.date_picker.pickerOpen) this.fetchPaymentPlanItems()
    },
    onMakePayment() {
      this.$refs.make_payments.preload = true
      postReservationsPaymentRequest({ payments_plans: this.checked.map(item => item.id) })
        .finally(() => { this.$refs.make_payments.preload = false })
        .then(() => {
          this.fetchPaymentPlanItems()
          this.$notify({
            type: 'success',
            title: 'Payment made successfully',
          })
          this.checked = []
        })
    },
    fetchPaymentPlanItems() {
      this.table_preloader = true
      getReservationsPaymentPlanMeals({
        page: this.pagination_payment_plan.page,
        page_size: 40,
        search: this.search,
        hotel: this.filter_hotel,
        paid: this.filter_paid,
        requested: this.filter_paid === 'true' ? null : 'false',
        hotel_chain: this.filter_hotel_chain,
        date_after: this.filter_dates?.start,
        date_before: this.filter_dates?.end,
      })
        .then(res => {
          this.table_payment_plan.items = res.data.results
          this.pagination_payment_plan.pages = res.data.pages
          this.pagination_payment_plan.count = res.data.count
          this.is_page_loaded = true
          this.table_preloader = false
        })
    },
    onClickPaymentPlanPagination(page) {
      this.pagination_payment_plan.page = page
      this.fetchPaymentPlanItems()
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    amountFormat(amount) {
      return amount ? new Intl.NumberFormat('ru-RU').format(amount) : '-'
    },
    onLeadSearch(search) {
      this.searchLeadName(search, this)
    },
    searchLeadName: debounce((search, vm) => {
      vm.pagination_payment_plan.page = 1
      vm.fetchPaymentPlanItems()
    }, 350),
  }
}
</script>
